import { render } from "./FlashMessages.vue?vue&type=template&id=808b0ef4&ts=true"
import script from "./FlashMessages.vue?vue&type=script&lang=ts"
export * from "./FlashMessages.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__